import { Component, inject, OnDestroy, OnInit, output, signal } from "@angular/core";
import { Aul10124Component } from "./aul-101-24/aul-101-24.component";
import { Aul10224Component } from "./aul-102-24/aul-102-24.component";
import { Aul10324Component } from "./aul-103-24/aul-103-24.component";
import { Aul10624Component } from "./aul-106-24/aul-106-24.component";
import { jsPDF } from 'jspdf';
import { ToastService } from "../../services/toast.service";
import { ToastType } from "../../enums/config.enum";
import { Aul10424Component } from "./aul-104-24/aul-104-24.component";
import { QuoteDocumentService } from "../../services/quoteDocument.service";
import { Subscription } from "rxjs";
import { AuthService } from "../../auth/auth.service";
import { SpinnerComponent } from "../utils/spinner/spinner.component";
import { EmailDistributionService } from "../../services/email-distribution.service";
import { GetUserDetails } from "../../models/sessionStorage.model";
import { saveAs } from "file-saver";

@Component({
    selector: "app-quote-documents",
    standalone: true,
    imports: [Aul10124Component, Aul10224Component, Aul10324Component, Aul10624Component, SpinnerComponent],
    templateUrl: './quote-documents.component.html',
    styleUrl: './quote-documents.component.scss'
})
export class QuoteDocuments implements OnInit, OnDestroy{
  
    isGeneratingPDF = signal(false);
    toastService = inject(ToastService);
    authService = inject(AuthService);
    emailService = inject(EmailDistributionService)
    quoteDocumentService = inject(QuoteDocumentService);
    storageData = signal<GetUserDetails | null>(null);
    userId = signal<string | null>('');
    branchId = signal<string | null>('');
    quoteDetails = signal<any>('');
    quoteDocumentSubs = new Subscription();
    EmailSubs = new Subscription();
    downloadEmailCompleteEmitter = output<boolean>();
    quoteNo = signal('');
    pdf: any = '';
    documentMessage: string =""

    ngOnInit(): void {
      
      this.quoteDocumentSubs = this.quoteDocumentService.getDownloadQuoteDocument().subscribe({
        next: (response: boolean) => {
          if(response){
            this.getQuoteDocumentDetails('download');
            this.quoteDocumentService.setDownloadQuoteDocument(false); // reset the policy document download trigger
          }
        }
      });

      this.EmailSubs = this.quoteDocumentService.getEmailQuoteDocument().subscribe({
        next: (response: boolean) => {
          if(response){
            this.getQuoteDocumentDetails('email');
            this.quoteDocumentService.setEmailQuoteDocument(false); // reset the email trigger
          }
        }
      });
    }

    getQuoteDocumentDetails(type: string) {
      const payloadId = this.authService.isPolicyType() ?  Number(this.authService.getUserDetailsFromStorage()?.policyId) :
      Number(this.authService.getUserDetailsFromStorage()?.quoteId)
      const isQuote = this.authService.isPolicyType() ? "0" : "1";
      this.quoteDocumentService.onDownloadQuoteDocument(payloadId, 
        Number(this.authService.getUserDetailsFromStorage()?.branchId), isQuote).subscribe({
        next: (response: any) => {
          if(response){
            this.toastService.addNotification({message: "Document generation In progress", type: ToastType.Info});
            this.quoteDetails.set(response[0]); // bind the data
            this.quoteNo.set(response[0]?.aul10124?.quoteNo);
            setTimeout(() => {
              this.generatePDF(type); // generate the pdf
            
          }, 0);
          }
        },
        error: (error: any) => {
          console.log("error", error);
          this.toastService.addNotification({message: "System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
        }
      });
    }
  
    async generatePDFNew(): Promise<void> {
      this.isGeneratingPDF.set(true);
      let pdf = new jsPDF("l", "pt", "a4", true);

      const pages: any = document.getElementById('quote-pdf-pages')?.innerHTML;
      let pdfQuoteNo = this.quoteNo();
      const self = this;
      pdf.html(pages, {
       callback: function(doc) {
        self.isGeneratingPDF.set(true);
         const totalPages = doc.getNumberOfPages();
         for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
           doc.setPage(pageNumber);
           doc.setFontSize(8);
           doc.setTextColor("black");
           doc.text(`Page: ${pageNumber}/${totalPages}`, 10, doc.internal.pageSize.height - 5);
         }
         self.isGeneratingPDF.set(false);
         pdf.save("Quote Document_" + pdfQuoteNo + ".pdf");
         self.toastService.addNotification({message: "Document generation Completed", type: ToastType.Success});
       },
       html2canvas: {
           scale: 0.9,
           logging: false,
           windowWidth: 910 // 816 = letter paper pixel width at 96dpi (web), 786 = less the 30px margin
       },
       x: 0,
       y: 0,
       margin: [15, 10, 15, 10], // mm
       width: 910, // 216 = letter paper width in mm, 208 = less the 8mm margin
       windowWidth: 910,  // 816 = letter paper pixel width at 96dpi (web), 786 = less the 30px margin
  
      });
    }

    async generatePDF(type: string): Promise<void> {
        this.isGeneratingPDF.set(true);
        const sanitizeFooterText = (value: any): string => {
          const joinLettersWithSubtleSpacing = (token: string): string => {
            const chars = token.split("");
            const sep = "\u2009";
            return chars.reduce((acc, ch, i) => {
              if (i === 0) {
                return ch;
              }
              const prev = chars[i - 1];
              if (
                String(prev).toUpperCase() === "A" &&
                (String(ch).toUpperCase() === "N" || String(ch).toUpperCase() === "U" || String(ch).toUpperCase() === "T" || String(ch).toUpperCase() === "G" || String(ch).toUpperCase() === "R")
              ) {
                return acc + ch;
              }
              return acc + sep + ch;
            }, "");
          };

          const normalized = String(value ?? "")
            .normalize("NFKC")
            .replace(/[\u00AD\u200B-\u200D\uFEFF]/g, "")
            .replace(/\t/g, " ")
            .replace(/\s+/g, " ")
            .trim()
            .replace(/ENHA\s+NCEMENT/gi, "ENHANCEMENT");

          // Keep visible word gaps in renderers that collapse/condense regular spaces.
          const withWordSpacing = normalized.replace(/ /g, "\u00A0\u00A0");
          return withWordSpacing
            .split("\u00A0\u00A0")
            .map((token) => joinLettersWithSubtleSpacing(token))
            .join("\u00A0\u00A0");
        };
        let footerData : any = {
          "app-aul-101-24" : {
           text : "AUL POLICY APPLICATION AND QUOTE SUMMARY 101/24"
          }, 
          "app-aul-104-24" : {
           text : "AUL POLICY APPLICATION AND QUOTE SUMMARY 101/24"
          }, 
          "app-aul-102-24" : {
           text : "AUL COMMERCIAL PROPERTY QUOTE LIMITS 102/24"
          }, 
          "app-aul-103-24" : {
           text : "AUL POLICY APPLICATION INFORMATION 103/24"
          }, 
          "app-aul-106-24" : {
           text : "AUL TRIA NOTICE 106/24"
          }
        };
        Object.keys(footerData).forEach((key) => {
          const item = footerData[key];
          if (!item) {
            return;
          }
          if (item.text !== undefined) {
            item.text = sanitizeFooterText(item.text);
          }
          if (item.textLeft !== undefined) {
            item.textLeft = sanitizeFooterText(item.textLeft);
          }
          if (item.center !== undefined) {
            item.center = sanitizeFooterText(item.center);
          }
        });

        let formDataArr = [];
        const pages = document.querySelectorAll('.quote-pdf-page');
        for (let i = 0; i < pages.length; i++) {
          let className: string =
          pages[i].className
            .split(" ")
            .find((className) => className.startsWith("app-")) || "";
          const formDataObj = {
            formName: className,
            formData: JSON.parse(JSON.stringify(pages[i].innerHTML)),
            formFooter: footerData[className],
          };
          if(className != ''){
            formDataArr.push(formDataObj);
            }
        }
     
         if(type === "download"){
         this.quoteDocumentService.downloadPdf(formDataArr).subscribe(
           (blob) => {
             const quoteNoPdf = sessionStorage.getItem("quoteNo");
             const nameInsuredPdf = sessionStorage.getItem("nameInsured");
             const documentName =
               "Quote_" + quoteNoPdf + "_" + nameInsuredPdf + ".pdf";
            saveAs(blob, documentName);
            this.toastService.addNotification({
              message: "Document download Completed",
              type: ToastType.Success,
            });
            // Update download/email complete flag after successful download
           
            const quoteNo = sessionStorage.getItem("quoteNo");
         const userEmail = sessionStorage.getItem("userEmail");
         const nameInsured = sessionStorage.getItem("nameInsured");
         const payload = {
           formDataList: formDataArr,     
           document: {
             toEmail: userEmail,
             docNo: quoteNo,
             docType: 'Quote',
             docName: nameInsured,    
            }
         };
         this.quoteDocumentService.emailPdf(payload).subscribe({
           next: (response: any) => {
             this.updateDownloadEmailCompleteFlag();
           },
           error: (error) => {
           }
         });
           },
           (error) => {}   
         );
       }else{
         const quoteNo = sessionStorage.getItem("quoteNo");
         const userEmail = sessionStorage.getItem("userEmail");
         const nameInsured = sessionStorage.getItem("nameInsured");
         const payload = {
           formDataList: formDataArr,     
           document: {
             toEmail: userEmail,
             docNo: quoteNo,
             docType: 'Quote',
             docName: nameInsured,    
            }
         };
         this.quoteDocumentService.emailPdf(payload).subscribe({
           next: (response: any) => {
             this.toastService.addNotification({
               message: "Email Sent Sucessfully",
               type: ToastType.Success,
             });
             // Update download/email complete flag after successful email
             this.updateDownloadEmailCompleteFlag();
           },
           error: (error) => {
           }
         });
       }
         this.isGeneratingPDF.set(false);
    }

    updateDownloadEmailCompleteFlag() {
        const storageData = this.authService.getUserDetailsFromStorage();
        const quoteId = this.authService.isPolicyType() 
            ? storageData?.policyId 
            : storageData?.quoteId;
        const userId = storageData?.userDetails?.userId;
        
        const versionNo = Number(sessionStorage.getItem("versionNo"));
        
        if (quoteId && userId && versionNo) {
            this.quoteDocumentService.UpdateIsDownloadEmailComplete(
                Number(quoteId),
                Number(userId),
                versionNo,
                1
            ).subscribe({
                next: (response: any) => {
                    // Flag updated successfully - emit event to parent component
                    this.downloadEmailCompleteEmitter.emit(true);
                },
                error: (error: any) => {
                    // Handle error silently or log if needed
                }
            });
        }
    }

    

    SendEmail(base64Document: string) {
      const storageData = this.authService.getUserDetailsFromStorage();
      this.storageData.set(storageData);
      this.userId.set(String(storageData?.userDetails?.userId));
      this.branchId.set(String(storageData?.branchId));
      const QuoteNo = sessionStorage.getItem('quoteNo');
      const userEmail = sessionStorage.getItem('userEmail');
      const nameInsured = sessionStorage.getItem('nameInsured');

      const payload = {
        userId: this.userId(),
        policyNo: QuoteNo,
        policyName: nameInsured,
        branchId: this.branchId(),
        type: 'Quote',
        toEmail: userEmail,
        documentData: `${base64Document}`,
      };
  
      this.emailService.SendEmailDistribution(payload).subscribe({
        next: (response: any) => {
          if(response){
          this.toastService.addNotification({message: response.message, type: ToastType.Success});
          }
        },
        error: (error: any) => {
        
        }
      });
    }
  

  ngOnDestroy(): void {
    this.quoteDocumentSubs?.unsubscribe();
    this.EmailSubs?.unsubscribe();
  }
}
